import Duck from "redux-ducks-ts"

export const permission = new Duck("permission", "cargo")
